import NiceModal from '@ebay/nice-modal-react';

import { useNavigate } from 'react-router-dom';

import Button from 'components/field/Button';
import Card from 'components/global/Card';
import Typography from 'components/global/Typography';

import useAppTracking from 'hooks/useAppTracking';

import ReportsPreFilterModal from 'pages/Reports/Reports/ReportsPreFilterModal';

import * as S from './styled/ReportCard.styled';

/**
 * @author @omerrkosar
 */

const ReportCard = ({ title, subTitle, actionPath, actionLabel, filterArray }) => {
	const navigate = useNavigate();
	const { track } = useAppTracking();

	const handleModalClick = () => {
		NiceModal.show(ReportsPreFilterModal, {
			title,
			actionPath,
			filterArray
		});
	};

	const handleClick = () => {
		track('reportsGenerated', { name: title, dateStart: '', dateEnd: '' }, ['mixpanel']);
		navigate(actionPath);
	};

	return (
		<div>
			<Card fullHeight>
				<S.RowContainer>
					<div>
						<Typography variant="p2" fontWeight="500" noWrap fullWidth>
							{title}
						</Typography>
						<Typography maxlines={2} noWrap>
							{subTitle}
						</Typography>
					</div>
					<div>
						<Button
							label={actionLabel}
							onClick={filterArray ? handleModalClick : handleClick}
							variant="outline"
						/>
					</div>
				</S.RowContainer>
			</Card>
		</div>
	);
};

export default ReportCard;
